import React, { useEffect } from 'react';
import { Button } from '@hangar/web-components/core/Button';
import { useAssets } from '../../hooks/utils';
import { useDocumentHeadTitle } from '../../hooks/utils/useDocumentHeadTitle';
import { LATAM_CARGO_PUBLIC_PAGE_TITLES } from '../../utils/documentHeadTitle';
import * as S from './UnsubscribeThankYouPage.styles';
import { useTranslation } from '../../hooks/i18n';

const CUSTOMERCARE_EMAIL = 'customercaremia@latam.com';
const LATAMCARGO_URL = 'https://www.latamcargo.com';
const UNSUBSCRIBE_THANK_YOU_ICON =
  'https://image.mails.latam.com/lib/fe3111717d64047b741c71/m/1/eab0554a-3763-4a86-bbe6-fc49f75efdd5.png';

export const UnsubscribeThankYouPage: React.FC = () => {
  const { assets } = useAssets();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage('en');
  }, []);

  useDocumentHeadTitle(LATAM_CARGO_PUBLIC_PAGE_TITLES.unsubscribed);

  return (
    <S.Container>
      <S.LogoContainer>
        <S.Logo src={assets.logos.latamCargo} alt="LATAM CARGO" />
      </S.LogoContainer>
      <S.Card>
        <S.IconWrapper>
          <img src={UNSUBSCRIBE_THANK_YOU_ICON} alt="" role="presentation" />
        </S.IconWrapper>
        <S.Title>{t('unsubscribe.thankYouMessage')}</S.Title>
        <S.ResubscribeText>
          If you wish to receive information from LATAM Cargo again, please contact us at{' '}
          <a href={`mailto:${CUSTOMERCARE_EMAIL}`}>{CUSTOMERCARE_EMAIL}</a>.
        </S.ResubscribeText>
        <S.ButtonWrapper>
          <Button
            label="Ir a LATAM Cargo"
            variant="primary"
            onClick={() => window.open(LATAMCARGO_URL, '_blank', 'noopener,noreferrer')}
            data-testid="unsubscribe-goto-latamcargo"
          />
        </S.ButtonWrapper>
      </S.Card>
    </S.Container>
  );
};
